<template lang="pug">
	div(class="resume-wide resume-vertical-scroll" style="border:none;")
			div(@click="m_editMode")
				div(class="section-title")
					<strong class="primary">📜Certifications</strong><sup title="Toggle Edit" variant="outline-primary" style="border:none;"><fa-icon icon="pencil-alt" /></sup>			
			div(v-if="d_editMode")
				b-table(id="certification" :fields="d_certificationFields" :items="d_certifications" class="font-weight-bold" style="font-size: 12px;" sticky-header="2000px"
					small striped responsive borderless hover selectable 	select-mode="single" 	selected-variant="success" 	show-empty 	tbody-tr-class="rowStyle" 
					@row-clicked="m_clicked" @row-dblclicked="m_dblClicked('education', $event)"
					)
					<!-- Degree column -->
					<template v-slot:cell(name)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.name }}</div>
						<b-form-input v-else v-model="data.item.name"   size="sm"  />
					</template>
					<!-- field column -->
					<template v-slot:cell(issuer)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.issuer }}</div>
						<b-form-input v-else v-model="data.item.issuer"   size="sm"  />
					</template>
					<template v-slot:cell(issueDate)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.issueDate }}</div>
						<input v-else type="date" v-model="data.item.issueDate" />
					</template>
					<template v-slot:cell(expiryDate)="data">
						<div v-if="d_selectedIndex !== data.index">{{ data.item.expiryDate }}</div>
						<input v-else type="date" v-model="data.item.expiryDate" />
					</template>
					template(#empty="scope")
						span No Certifications!!
				div(v-if="d_copyPaste")
					<vue-editor ref="editor" v-model="d_copyPasteData" :editorToolbar="d_editorModules" @ready="m_onEditorReady" :placeholder="d_placeholder"></vue-editor>
			div(v-else)
				div(v-if="d_certifications.length>0")
					div( v-for="c in d_certifications" :key="c.name")
						<span v-html="m_getCertification(c)"></span>
				span(v-else) No Certifications!!
</template>
<script>
import {VueEditor} from "vue2-editor";
export default {
  name: "resumeCertification",
  components: {VueEditor},
  data() {
    return {
		d_newRecord:{},
		d_certficationFields:[{key:"name",field:"name",title:"Certificate",type:"input", datatype:"text",required:true},
						{key:"issuer",field:"issuer",title:"Issuer",type:"input", datatype:"text",required:true},
						{key:"issueDate",field:"issueDate",title:"Issue Date",type:"input", datatype:"date"},
						{key:"expiryDate",field:"expiryDate",title:"Expiry Date",type:"input", datatype:"date"},
						],
		d_selectedIndex:null,
		d_deleteEnabled:null,
		d_editMode:this.p_editMode,
		d_certifications: [],
		d_newRecord:{name:null,issuer:null,issueDate:null, expiryDate:null },
		d_copyPaste:false,
		d_placeholder:"Format:Certification Name,Issuer,Issue Date,Expiry Date",
		d_editorModules: [
						['bold', 'italic', 'underline'],
                        [{  color: []}, { background: []}],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						['clean'],['upload']   // 👈 your custom button
						],
    };
  },
created(){this.d_certifications = (this.value || []).map(row => ({ ...row }));},
mounted(){},
props: {
		value: Array,
		p_editMode:Boolean,
},
computed: {},
methods: {
m_editMode() {
  this.d_editMode = !this.d_editMode;
  if(this.d_editMode) this.$emit("activate", "certifications");
  if(!this.d_editMode) this.d_copyPaste=false;
},
m_copyPaste(){this.d_copyPaste=!this.d_copyPaste;},
m_getCertification(data) {
	if(!data.name) return"";
	var rowData=null;
	if(data.name) rowData=`<strong style="color:#007bff;">${data.name}</strong>`;
	if(data.issuer) rowData=rowData+`<span style="color:black;"> issued by ${data.issuer}</span>`;
	if(data.issueDate) rowData = rowData+`<span style="color:black;"> on ${data.issueDate.toLocaleString()}</span>`;
	if(data.expiryDate) rowData = rowData+`<span style="color:black;"> , expires ${data.expiryDate.toLocaleString()}</span>`;        
	return rowData
	},
m_addRecord() {
	const recordId = Date.now() + Math.random();
	this.d_certifications.push(JSON.parse(JSON.stringify(this.d_newRecord)));

  // Open modal for editing
	this.d_editMode = true;
	this.d_selectedIndex=this.d_certifications.length-1;
},
m_clicked(row,index) {
    this.d_selectedIndex = index;	
},
m_dblClicked(table, row) {
	if (!this.d_selectedIndex) return;
    this.d_editMode = true;
},

m_save(){
	this.$emit("input", this.d_certifications);
},

m_undo(){
	this.d_certifications.length=0;
	this.d_certifications = (this.value || []).map(row => ({ ...row }))
},
m_deleteRecord(){
	let temp = [...this.d_certifications];
	temp.splice(this.d_selectedIndex, 1);
	this.d_certifications = this.temp.map(row => ({ ...row }));
},
m_processCopyPaste(){

console.log('In m_processCopyPaste');

//var fields=["degree","field","school","year"];
const html = this.quill.root.innerHTML;
const text = this.quill.getText();
const delta = this.quill.getContents();

console.log(text);

var pastedRows = text
    .split(/\r?\n/)              
    .map(line => line.trim()) 
    .filter(line => line.length) 
    .map(line => line.split(",")); 
pastedRows.forEach(r=>{
					var issueDate=null;
					var expiryDate=null;
                    var iDate=r[2].trim();
                    var eDate=r[3].trim();
					if(r[2]) issueDate=iDate.substring(6,10)+"-"+iDate.substring(3,5)+"-"+iDate.substring(0,2);
					if(r[3]) expiryDate=eDate.substring(6,10)+"-"+eDate.substring(3,5)+"-"+eDate.substring(0,2);
					var newRecord={name:r[0],issuer:r[1],issueDate:issueDate,expiryDate:expiryDate};
					this.d_certifications.push(newRecord);
				});

},
m_onEditorReady(editorInstance) {

    this.quill = editorInstance;

    // Find the toolbar DOM element
    const toolbarEl = this.quill.container.parentNode.querySelector('.ql-toolbar');

    if (toolbarEl) {
      // Create your custom button container
		const customBtn = document.createElement('button');
		customBtn.className = 'ql-custom-upload';
		customBtn.title = "Upload";
		customBtn.appendChild(document.createTextNode("📤"));

      // Attach click handler
      customBtn.addEventListener('click', this.m_processCopyPaste);

      // Inject into toolbar
      toolbarEl.appendChild(customBtn);
    }
  },
},
watch: {
p_editMode(newVal) {
    this.d_editMode = newVal;
  },
value: {
  immediate: true,
  deep: true,
  handler(newVal) {
    if (!newVal) return;
	this.d_resumeData = newVal.resumeData;
    this.d_certifications = newVal.map(row => ({ ...row }))
  }
 },
  
}, 
}
</script>
<style scoped>
.cv-container {
  max-width: 900px;
  margin: auto;
}
section {
  margin-bottom: 2rem;
}
.section-header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.timeline {
  position: relative;
  list-style: none;
  padding-left: 30px;
  margin-top: 1rem;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #ddd;
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  cursor: grab;
}

.dot {
  position: absolute;
  left: 4px;
  top: 18px;
  width: 16px;
  height: 16px;
  background: #2c7be5;
  border-radius: 50%;
}

.card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 1rem;
  margin-left: 20px;
}

input,
textarea {
  width: 100%;
  margin-bottom: 0.5rem;
}

.row {
  display: flex;
  gap: 0.5rem;
}

button {
  cursor: pointer;
}

.debug {
  background: #f7f7f7;
  padding: 1rem;
  font-size: 0.8rem;
}
.header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.header-btn .emoji {
  font-size: 1.2rem;
  cursor: pointer;
}
.emoji {
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.emoji:hover {
  background: #f0f0f0;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒";     /* "🡒" */
  color: #1E90FF; 
}
details[open] summary::before { 
  content:"🠣";  /* "🠣""🡑"*/ 
  color: #1E90FF; 
}
.btn-add {
	text-align: right;
	border:none;
	}
.btn-delete {
	color: #dc3545;
	text-align: right;
	border:none;
	}
.btn-add {
	color: #4fa4ff;
	border:none;
	}
.btn-expand {
	color: #FFA500;
	border:none;
	}
.resume-wide {
  width: 100%;
  min-width: 1200px; /* or whatever your tables need */
  position: relative;
  z-index: 10;
  overflow-x: auto;
  overflow-y: auto;
}
.col-4 {
  overflow: visible !important;
}
.resume-flex-expand {
  flex: 1 1 100%;
  max-width: 100%;
}
.resume-wide textarea {
  border: 1px solid #ccc;
  padding: 12px;
  font-size: 14px;
  line-height: 1.4;
}
.resume-vertical-scroll {
  max-height: 4000px;   /* adjust to your needs */
  overflow-y: auto;
  overflow-x: hidden;  /* optional, keeps it tidy */
  border: none;
  border-radius: 4px;
  background: #fff;
}
table td {
  overflow: visible !important;
}
.datepicker-fix .dropdown-menu {
  z-index: 2000 !important;
}
#certification .b-table-sticky-header {
  overflow: visible !important;
}

#certification .table-responsive {
  overflow: visible !important;
}
.section-title {
    font-size: 15px;
    font-weight: 700;
    text-transform1: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
    margin-bottom: 12px;
  }
</style>
